<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Requisitions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Vehicle Requisitions",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "vehicle",
          label: "Vehicle",
          sortable: true,
        },
        {
          key: "staff",
          label: "Requested By",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "amount",
          label: "Budget",
          sortable: true,
        },
        {
          key: "desc",
          label: "Description",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        date: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
        description: "",
        staff: "",
        amount: 0,
        vehicle: "",
      },
      deletePos: {
        name: "",
        id: "",
      },
      take: {
        name: "",
        id: "",
      },
      editPos: {
        date: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
        description: "",
        staff: "",
        name: "",
        amount: "",
        vehicle: "",
        id: "",
      },
      approve: {
        date: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
        approver: "",
        name: "",
        vehicle: "",
        id: "",
      },
      descError: "",
      vehicleError: "",
      staffError: "",
      modal: "",
      pending: [],
      approved: [],
      taken: [],
    };
  },
  computed: {
    ...mapGetters("transport", ["Vehicles","Requisitions", "SaveStatus"]),
    ...mapGetters("staff", ["AllStaff"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.pending.length;
    },
  },
  watch: {
      SaveStatus(newValue){
          if(newValue){
              this.resetAddModal();
              this.closeModal(this.modal);
          }
      },
      Requisitions(newValue){
          if(newValue){
              this.assignData();
          }
      }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.pending.length;
  },
  methods: {
    ...mapActions({
      FetchVehicles: "transport/fetchVehicles",
      FetchRequisitions: "transport/fetchRequisitions",
      AddRequisition: "transport/addRequisition",
      EditRequisition: "transport/editRequisition",
      DeleteRequisition: "transport/deleteRequisition",
      ApproveRequisition: "transport/approveRequisition",
      TakeRequisition: "transport/taken",
      FetchStaff: "staff/fetchStaff",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.pending.length;
      this.currentPage = 1;
    },
    assignData(){
      this.pending = this.Requisitions.filter((req) => {
        return req.status==0;
      });
      this.approved = this.Requisitions.filter((req) => {
        return req.status==1;
      });
      this.taken = this.Requisitions.filter((req) => {
        return req.status==2;
      });
    },

    resetError() {
      this.descError = "";
      this.vehicleError = "";
      this.staffError = "";
    },

    resetAddModal() {
      this.data.date = new Date().toJSON().slice(0,10).replace(/-/g,'-');
      this.data.vehicle = "";
      this.data.staff = "";
      this.data.description = "";
      this.data.amount = 0;
      this.resetError();
    },

    addRequisition(modal) {
      if (this.data.vehicle == "") {
        this.vehicleError = "Select Vehicle being requested";
        return;
      } else {
        this.vehicleError = "";
      }
      if (this.data.staff == "") {
        this.staffError = "Choose the staff that is requesting";
        return;
      } else {
        this.staffError = "";
      }
      if (this.data.description == "") {
        this.descError = "Provide a brief description";
        return;
      } else {
        this.descError = "";
      }
      this.modal = modal;
      this.AddRequisition(this.data);
    },
    showEditModal(values) {
      this.editPos.id = values.item.id;
      this.editPos.date = values.item.date;
      this.editPos.description = values.item.desc;
      this.editPos.staff = values.item.staffId;
      this.editPos.name = values.item.staff;
      this.editPos.amount = values.item.amount;
      this.editPos.vehicle = values.item.vehicleId;
      this.editPos.car = values.item.vehicle;
    },
    showApproveModal(values) {
      this.approve.id = values.item.id;
      this.approve.date = values.item.date;
      this.approve.name = values.item.staff;
      this.approve.vehicle = values.item.vehicle;
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.name = values.item.staff;
    },
    showTakeModal(values) {
      this.take.id = values.item.id;
      this.take.name = values.item.staff;
    },
    deleteRequisition(modal) {
      this.modal = modal;
      this.DeleteRequisition(this.deletePos);
    },
    takeRequisition(modal) {
      this.modal = modal;
      this.TakeRequisition(this.takePos);
    },
    editRequisition(modal) {
      if (this.editPos.vehicle == "") {
        this.vehicleError = "Select Vehicle being requested";
        return;
      } else {
        this.vehicleError = "";
      }
      if (this.editPos.description == "") {
        this.descError = "Provide a brief description";
        return;
      } else {
        this.descError = "";
      }
      if (this.editPos.staff == "") {
        this.staffError = "Choose the staff that is requesting";
        return;
      } else {
        this.staffError = "";
      }
      this.modal = modal;
      this.EditRequisition(this.editPos);
    },
    approveRequisition(modal) {
      if (this.approve.staff == "") {
        this.staffError = "Choose the staff that is approving";
        return;
      } else {
        this.staffError = "";
      }
      this.modal = modal;
      this.ApproveRequisition(this.approve);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchVehicles();
    this.FetchRequisitions();
    this.FetchStaff();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_position')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of School Vehicles Requisitions</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_position')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="pending?pending:[]"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(status)="">
                  <span class="text-warning">Pending</span>
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="success"
                      v-b-modal.approve-modal
                      @click="showApproveModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-check"></i> Approve</b-button
                    >
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_position')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_position')
          )
        "
      >
        <template #modal-title> Request For School Vehicle </template>
        <div class="form-group mb-3">
          <label>Date to be Used</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              @input="resetError"
              v-model="data.date"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Money Support Needed</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Estimated budget for the Trip/Journey"
              class="form-control"
              v-model="data.amount"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Select Vehicle</label>
          <div class="input-group">
            <model-list-select
                required
                :list="Vehicles ? Vehicles : []"
                v-model="data.vehicle"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Vehicle"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="vehicleError">
            <em>{{ vehicleError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Requested By</label>
          <div class="input-group">
            <model-list-select
                required
                :list="AllStaff ? AllStaff : []"
                v-model="data.staff"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Staff"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Description</label>
          <div class="input-group">
            <textarea name="" class="form-control" v-model="data.description"></textarea>
          </div>
          <div class="text-danger" v-if="descError">
            <em>{{ descError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addRequisition('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Edit Requisition for {{ editPos.car }} made by {{ editPos.name }}</template>
        <div class="form-group mb-3">
          <label>Date to be Used</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              @input="resetError"
              v-model="editPos.date"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Money Support Needed</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Estimated budget for the Trip/Journey"
              class="form-control"
              v-model="editPos.amount"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Select Vehicle</label>
          <div class="input-group">
            <model-list-select
                required
                :list="Vehicles ? Vehicles : []"
                v-model="editPos.vehicle"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Vehicle"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="vehicleError">
            <em>{{ vehicleError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Requested By</label>
          <div class="input-group">
            <model-list-select
                required
                :list="AllStaff ? AllStaff : []"
                v-model="editPos.staff"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Staff"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Description</label>
          <div class="input-group">
            <textarea name="" class="form-control" v-model="editPos.description"></textarea>
          </div>
          <div class="text-danger" v-if="descError">
            <em>{{ descError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editRequisition('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Requistion made by {{ deletePos.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Requistion made by {{ deletePos.name }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteRequisition('delete-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- edit modal starts -->
      <b-modal
        id="approve-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Approve Requisition for {{ approve.vehicle }} made by {{ approve.name }}</template>
        <div class="form-group mb-3">
          <label>Date Approved</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              v-model="approve.date"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Approved By</label>
          <div class="input-group">
            <model-list-select
                required
                :list="AllStaff ? AllStaff : []"
                v-model="approve.approver"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Staff"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('approve-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="approveRequisition('approve-modal')"
          >
            <i class="fa fa-check"></i>
            Approve</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="take-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Mark Vehicle as taken {{ take.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to mark Requistion made by {{ take.name }} as taken? Click Proceed
              Button to Confirm.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('take-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="takeRequisition('take-modal')"
          >
            <i class="fa fa-check"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Confirming"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
